export const RENTAL_CATEGORIES = ["Real Estate", "Vehicles", "Equipment", "Spaces", "Other"];
export const RENTAL_UNITS = [
  { id: "hour",  label: "/hr",  long: "hour" },
  { id: "day",   label: "/day", long: "day" },
  { id: "week",  label: "/wk",  long: "week" },
  { id: "month", label: "/mo",  long: "month" },
];
const SYMBOL = { USD: "$", EUR: "€", GBP: "£", AUD: "A$", CAD: "C$", JPY: "¥" };
const sym = (c) => SYMBOL[c] || `${c || "USD"} `;
export const fmt = (n, c) => `${sym(c)}${Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
export const rateLabel = (rates, currency) => {
  const order = ["day", "week", "month", "hour"];
  for (const u of order) {
    if (rates?.[u] != null) {
      const lbl = RENTAL_UNITS.find(x => x.id === u).label;
      return `${fmt(rates[u], currency)}${lbl}`;
    }
  }
  return "Rates on request";
};
